import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { syncSRAData } from '../services/organisationService';
import { Transition } from '@headlessui/react';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const [darkTheme, setDarkTheme] = useState(false);

  // Check if we're on the homepage to apply dark theme
  useEffect(() => {
    setDarkTheme(location.pathname === '/');
  }, [location.pathname]);

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'Search', href: '/search' },
    { name: 'About', href: '/about' },
    { name: 'Ask a Question', href: '/ask-a-question' },
    { name: 'Contact', href: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className={`header ${darkTheme ? 'dark-theme' : ''}`}>
      <div className="header__container">
        <div className="header__content">
          <Link to="/" className="header__logo">
            <svg width="40" height="40" viewBox="0 0 49 52" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 45.0562V2.22206C0 0.994851 0.994852 0 2.22206 0H39.4518C41.3574 0 42.379 2.24145 41.1289 3.67974L3.89918 46.5139C2.55082 48.0652 0 47.1116 0 45.0562Z" fill="url(#paint0_linear_10_872)"/>
              <path d="M49 48.8236V24.343C49 22.3234 46.5238 21.3511 45.1496 22.831L22.419 47.3116C21.0988 48.7334 22.1071 51.0457 24.0473 51.0457H46.7779C48.0051 51.0457 49 50.0508 49 48.8236Z" fill="url(#paint1_linear_10_872)"/>
              <defs>
                <linearGradient id="paint0_linear_10_872" x1="0.24833" y1="1.34331" x2="51.8042" y2="52.0243" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FE5F70"/>
                <stop offset="1" stop-color="#8B76E3"/>
                </linearGradient>
                <linearGradient id="paint1_linear_10_872" x1="0.24833" y1="1.34331" x2="51.8042" y2="52.0243" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FE5F70"/>
                <stop offset="1" stop-color="#8B76E3"/>
                </linearGradient>
              </defs>
            </svg>

            <span>Zahoot</span>
          </Link>

          <nav className="header__nav">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`header__nav-link ${
                  isActive(item.href) ? 'header__nav-link--active' : ''
                } ${darkTheme ? 'text-white' : ''}`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          <div className="header__actions">
            <Link to="/search" className="header__actions-button">
              Find a Solicitor
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className={`inline-flex items-center justify-center p-2 rounded-md hover:bg-opacity-50 ${darkTheme ? 'text-white hover:bg-gray-700' : 'text-gray-400 hover:text-gray-500 hover:bg-gray-100'}`}
            >
              <span className="sr-only">Open main menu</span>
              {!isOpen ? (
                <svg className="block h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              ) : (
                <svg className="block h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              )}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        <Transition
          show={isOpen}
          enter="transition ease-out duration-100 transform"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="transition ease-in duration-75 transform"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <div className="md:hidden">
            <div className={`px-2 pt-2 pb-3 space-y-1 sm:px-3 ${darkTheme ? 'bg-gray-900' : ''}`}>
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`block px-3 py-2 rounded-md text-base font-medium ${
                    isActive(item.href)
                      ? darkTheme ? 'text-purple-300 bg-purple-900' : 'text-blue-600 bg-blue-50'
                      : darkTheme ? 'text-gray-300 hover:text-white hover:bg-gray-700' : 'text-gray-700 hover:text-blue-600 hover:bg-blue-50'
                  }`}
                  onClick={() => setIsOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </div>
        </Transition>
      </div>
    </header>
  );
};

export default Header; 